import { useEffect } from 'react';
import { fireServedSectionEvent } from '../../TuesdaySale/saleInstrumentation';
import GeneralItemMarquee from '../GeneralItemMarquee';
import CountDown from '../TimerWithCTA/CountDown';
import {
  CountDownBox,
  FlexSection,
  TimerContainer,
  TimerHeading,
} from '../TimerWithCTA/styled';

export default function TimerWithMarquee(props) {
  const { data } = props;
  const marqueeData = data?.marqueeList;
  const colors = data?.gradientList?.join(',');

  useEffect(() => {
    fireServedSectionEvent(data);
  }, []);

  return (
    <TimerContainer bgColor={colors}>
      <FlexSection>
        <CountDownBox>
          <TimerHeading>{data?.heading}</TimerHeading>
          <CountDown data={data} />
        </CountDownBox>
      </FlexSection>

      <GeneralItemMarquee marqueeData={marqueeData} />
    </TimerContainer>
  );
}
